export default __webpack_public_path__ + "locales/en/VersionHistory.json?hash=298f0df948512ab5b7a0b05196fb6834";